import { Button, Stack, ViewItemFieldWithChildren } from '@fukuri-admins/ui/common';
import { StripePaymentField } from './StripePaymentField';
import styles from './styles.module.scss';

type Props = {
  /**
   * カードブランド名（日本語） + 下4桁のフォーマット済み表示文字列（例:「マスターカード（‥‥1234）」）。
   * カード未登録（404）の場合は undefined。
   */
  cardLabel?: string;
};

/**
 * ご契約情報 お支払い方法 Presentation
 *
 * - 決済方法（固定表示: クレジットカード払い）とカード情報（ブランド + 下4桁）を表示する
 * - カード未登録時（cardLabel が undefined）はカード情報行を表示しない
 * - 編集ボタンは配置のみ（押下時挙動は T03 で実装する）
 * - StripePaymentField（Payment Element）を編集ボタン行の下に配置する（表示のみ・配線は後続チケット）
 */
export const ContractInfoPaymentMethodPresentation: React.FC<Props> = ({ cardLabel }) => (
  <Stack direction='column' gap={24}>
    <h2 className={styles.title}>お支払い方法</h2>
    <ViewItemFieldWithChildren label='決済方法' direction='row'>
      <Stack direction='column' gap={8}>
        <span>クレジットカード払い</span>
        <Stack direction='row' gap={24} alignItems='center'>
          {cardLabel && <span>{cardLabel}</span>}
          <Button variant='secondary' size='sm'>
            編集
          </Button>
        </Stack>
      </Stack>
    </ViewItemFieldWithChildren>
    <StripePaymentField />
  </Stack>
);
